import { slugifyForSanityText } from '../../SanityComponents/utils'
import type { ArticleHeading } from './types'

const HEADING_SELECTOR = 'h2'

// Reads the rendered article body rather than its source, so the layout works
// over any children — portable text, exported HTML, MDX or plain JSX — without
// them cooperating.
//
// Headings rendered by SanityTextRenderer already carry an id, and the help
// center export carries editor block ids; those are reused verbatim so every
// published anchor link keeps resolving. Only the ones missing an id get a
// generated one, which is then assigned back so the anchor exists.
export function collectHeadings(root: HTMLElement): ArticleHeading[] {
  const headings: ArticleHeading[] = []
  const usedIds = new Set<string>()

  for (const element of root.querySelectorAll<HTMLElement>(HEADING_SELECTOR)) {
    const title = element.textContent?.trim() ?? ''
    if (!title) {
      continue
    }

    let id = element.id || slugifyForSanityText(title)
    if (!id) {
      continue
    }
    // slugifyForSanityText has no dedupe, so two sections with the same title
    // would otherwise share an id and the second link would scroll to the first.
    if (usedIds.has(id)) {
      let suffix = 2
      while (usedIds.has(`${id}-${suffix}`)) {
        suffix += 1
      }
      id = `${id}-${suffix}`
    }
    usedIds.add(id)

    if (element.id !== id) {
      element.id = id
    }

    headings.push({ id, title, level: Number(element.tagName.slice(1)) })
  }

  return headings
}
